// src/resources/PromoCodes.js

import React from 'react';
import { 
    List, 
    Datagrid, 
    TextField, 
    DateField, 
    Create, 
    SimpleForm, 
    TextInput, 
    NumberInput, 
    SelectInput, 
    DateInput,
    required, 
    ReferenceField,
    DeleteButton,
    FunctionField // <-- هام: استيراد FunctionField
} from 'react-admin';
import { Box, Typography } from '@mui/material';

const PromoCodeFilters = [
    <TextInput source="code" label="Search by Code" alwaysOn />,
    <SelectInput source="type" choices={[
        { id: 'ENERGY', name: 'Energy Grant' },
        { id: 'SUBSCRIPTION', name: 'Subscription Grant' },
    ]} />,
];

export const PromoCodeList = (props) => (
    <List {...props} sort={{ field: 'createdAt', order: 'DESC' }}>
        <Datagrid rowClick="edit">
            <TextField source="code" />
            <TextField source="type" />
            <TextField source="amount" label="Value" />
            
            {/* --- [تعديل] إضافة عمود عدد مرات الاستخدام --- */}
            <FunctionField 
                label="Used Count" 
                render={record => {
                    // Prisma يعيد العداد داخل _count
                    return `${record._count?.usages || 0} / ${record.maxUses}`;
                }} 
            />
            {/* -------------------------------------------- */}

            <DateField source="expiresAt" label="Expires At" showTime />
            <DateField source="createdAt" showTime />
            <ReferenceField source="userId" reference="users" label="Created By">
                <TextField source="name" />
            </ReferenceField>
            <DeleteButton mutationMode="pessimistic" />
        </Datagrid>
    </List>
);

const validateRequired = required();
const validateCodeFormat = [required(), code => (code && code.length < 3 ? 'Code must be at least 3 characters' : undefined)];

export const PromoCodeCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
            <Typography variant="h6" gutterBottom>Create New Promo Code</Typography>
            <Box sx={{ p: 1 }}>
                <TextInput source="code" validate={validateCodeFormat} helperText="Unique code (e.g., BONUS100)" fullWidth />
                
                {/* --- [تعديل] إضافة خيار WALLET --- */}
                <SelectInput source="type" validate={validateRequired} choices={[
                    { id: 'ENERGY', name: 'Energy Grant' },
                    { id: 'SUBSCRIPTION', name: 'Subscription Grant' },
                    { id: 'WALLET', name: 'Wallet Money (EGP)' }, // <-- الخيار الجديد
                ]} fullWidth />
                {/* -------------------------------- */}
                
                <NumberInput 
                    source="amount" 
                    label="Amount" 
                    helperText="For Wallet: Amount in EGP (e.g. 100). For Energy: Amount of Energy."
                    validate={validateRequired} 
                    min={1}
                />
                
                {/* مدة الصلاحية (غير مؤثرة في المحفظة لأن الرصيد دائم، لكن يمكن تركها كقيمة افتراضية) */}
                <NumberInput 
                    source="durationDays" 
                    label="Duration (Days)" 
                    helperText="Relevant for Subscription only. For Wallet, leave default."
                    min={1}
                    defaultValue={30}
                />
                
                <NumberInput 
                    source="maxUses" 
                    label="Max Uses (Total Users)" 
                    helperText="How many users can redeem this code?"
                    validate={validateRequired} 
                    min={1}
                    defaultValue={1000}
                />
                
                <DateInput 
                    source="expiresAt" 
                    label="Code Expiry Date" 
                    validate={validateRequired} 
                    fullWidth 
                />
            </Box>
        </SimpleForm>
    </Create>
);